export default "__VITE_ASSET__DFUMc3N5__"